import { useEffect } from "react";
import type { QueryClient } from "@tanstack/react-query";

import { flushOrderCommands } from "../command-queue/orderStatusQueue";

export function useQueueWorker(
  queryClient: QueryClient,
  enabled: boolean,
): void {
  useEffect(() => {
    if (!enabled) return;
    const flush = () => void flushOrderCommands(queryClient);
    const timer = window.setInterval(flush, 10_000);
    window.addEventListener("online", flush);
    document.addEventListener("visibilitychange", flush);
    flush();
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("online", flush);
      document.removeEventListener("visibilitychange", flush);
    };
  }, [queryClient, enabled]);
}
